import { useDispatch } from 'react-redux'

// Actions
import { actions as profileActions } from 'modules/profile/actions'

// Components
import { Spinner, Error, Layout } from '@tracklib/kit'
import DeleteAccountForm from 'components/profile/deleteaccountform'
import EmailNotificationsForm from 'components/profile/emailnotificationsform'
import EmailsForm from 'components/profile/emailsform'
import PasswordForm from 'components/profile/passwordform'
import ProfileFormView from 'components/profile/profileformview'
import SocialsForm from 'components/profile/socialsform'
import SEO from 'components/base/seo'
import CurrentPlan from 'components/profile/currentplan'

// Hooks
import { useProfile } from 'modules/profile/hooks'
import { useRequest } from 'modules/requests/hooks'

// Types
import type { Dispatch } from 'types'

// Utils
import { isBrowser } from '@process'

import styles from './settings.css'

const SettingsPage = () => {
  const dispatch = useDispatch<Dispatch>()
  const profile = useProfile()
  const profileRequest = useRequest('FETCH_PROFILE')

  if (!profile || !profile.alias) {
    if (profileRequest.isLoading || !isBrowser) {
      return <Spinner minHeight={500} delay={0} />
    } else {
      return <Error />
    }
  }
  const mergedProfile = {
    ...profile,
    is_subscribed: !profile.is_unsubscribed,
  }

  return (
    <>
      <SEO title="Settings | Tracklib" />
      {profile && (
        <Layout.FullWidth maxWidth={890}>
          <div className={styles.profileSettings}>
            <h1 className={styles.heading}>Settings</h1>
            <ProfileFormView />
            <SocialsForm />
            <CurrentPlan />
            <EmailsForm
              emails={mergedProfile.emails}
              addEmail={email => dispatch(profileActions.addEmail(email))}
              deleteEmail={email => dispatch(profileActions.deleteEmail(email))}
              setPrimaryEmail={email => dispatch(profileActions.setPrimaryEmail(email))}
            />
            <EmailNotificationsForm
              onSubmit={data => dispatch(profileActions.toggleEmailNotifications(!!data.is_subscribed))}
              isSubscribed={mergedProfile.is_subscribed}
            />
            <PasswordForm onSubmit={data => dispatch(profileActions.changePassword(data))} />
            <DeleteAccountForm />
          </div>
        </Layout.FullWidth>
      )}
    </>
  )
}

export default SettingsPage
